export * from './factors.component';
export * from './edit/edit.component';
